/* Kingdom Silver – Theme JS */
(function () {
  'use strict';

  /* ── Theme toggle ─────────────────────────────────── */
  const root = document.documentElement;
  const toggle = document.getElementById('themeToggle');
  const iconSun = document.getElementById('iconSun');
  const iconMoon = document.getElementById('iconMoon');

  function applyTheme(theme) {
    root.setAttribute('data-theme', theme);
    localStorage.setItem('ks-theme', theme);
    if (iconSun && iconMoon) {
      iconSun.style.display  = theme === 'dark' ? 'none' : '';
      iconMoon.style.display = theme === 'dark' ? ''     : 'none';
    }
  }

  const saved = localStorage.getItem('ks-theme') ||
    (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  applyTheme(saved);

  if (toggle) {
    toggle.addEventListener('click', () => {
      applyTheme(root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark');
    });
  }

  /* ── Nav scroll shadow ────────────────────────────── */
  const nav = document.getElementById('mainNav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.background = window.scrollY > 20
        ? 'rgba(18, 38, 59, 0.98)'
        : 'rgba(18, 38, 59, 0.95)';
    }, { passive: true });
  }

  /* ── Mobile menu + submenu toggles ────────────────── */
  const burger   = document.getElementById('navBurger');
  const navLinks = document.getElementById('navLinks');
  const isMobile = () => window.matchMedia('(max-width: 960px)').matches;  // must match the CSS nav breakpoint

  if (burger && navLinks) {
    burger.addEventListener('click', () => {
      const open = navLinks.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  // On mobile, a parent link taps open its dropdown instead of navigating.
  navLinks && navLinks.querySelectorAll('li.has-sub > .nav-sub-toggle').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (!isMobile()) return;
      e.preventDefault();
      const li = link.parentElement;
      const open = li.classList.toggle('open');
      link.setAttribute('aria-expanded', String(open));
    });
  });

  // Close the menu when the viewport grows back to desktop.
  window.addEventListener('resize', () => {
    if (isMobile() || !navLinks) return;
    navLinks.classList.remove('open');
    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
    }
    navLinks.querySelectorAll('li.open').forEach((li) => {
      li.classList.remove('open');
      const a = li.querySelector('.nav-sub-toggle');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  });

  // Esc closes any open dropdown.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !navLinks) return;
    navLinks.classList.remove('open');
    navLinks.querySelectorAll('li.open').forEach((li) => li.classList.remove('open'));
    if (burger) burger.setAttribute('aria-expanded', 'false');
  });

  /* ── Cart count badge ─────────────────────────────── */
  function updateCartCount(count) {
    const badge = document.getElementById('cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.dataset.count = count;
  }

  /* ── Add to cart (AJAX) ───────────────────────────── */
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = productForm.querySelector('.add-to-cart-btn');
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

      const formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(() => {
          if (btn) { btn.textContent = 'Added!'; }
          // Engraving is billed as a separate fee line, added right after.
          return typeof window.ksEngravingFee === 'function'
            ? window.ksEngravingFee()
            : null;
        })
        .then(() => fetch('/cart.js'))
        .then(r => r.json())
        .then(cart => {
          updateCartCount(cart.item_count);
          setTimeout(() => {
            if (btn) {
              btn.textContent = btn.dataset.label || 'Add to Cart';
              btn.disabled = false;
            }
          }, 1800);
        })
        .catch(() => {
          if (btn) { btn.textContent = 'Error — try again'; btn.disabled = false; }
        });
    });
  }

  /* ── Money formatting ─────────────────────────────── */
  const MONEY_FORMAT = (document.body && document.body.dataset.moneyFormat) || '${{amount}}';

  function formatMoney(cents, format) {
    const fmt = format || MONEY_FORMAT;
    const value = (cents || 0) / 100;

    function withCommas(n, decimals) {
      const parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    function withPeriods(n, decimals) {
      const parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join(',');
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount_no_decimals':                    return withCommas(value, 0);
        case 'amount_with_comma_separator':           return withPeriods(value, 2);
        case 'amount_no_decimals_with_comma_separator': return withPeriods(value, 0);
        default:                                      return withCommas(value, 2);
      }
    });
  }

  /* ── Quantity controls ────────────────────────────── */
  // Delegated so it covers the product page and the cart page, and keeps
  // working after cart rows are re-rendered.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.quantity-btn');
    if (!btn) return;
    e.preventDefault();

    const wrap  = btn.closest('.quantity-control') || btn.parentElement;
    const input = wrap && wrap.querySelector('.quantity-input');
    if (!input) return;

    const row    = input.closest('.cart-item');
    const isCart = !!row;
    const min    = isCart ? 0 : 1;              // 0 in the cart removes the line

    let val = parseInt(input.value, 10);
    if (isNaN(val)) val = min;
    val = btn.dataset.action === 'plus' ? val + 1 : Math.max(min, val - 1);

    input.value = val;
    if (isCart) queueCartUpdate(row, val);
  });

  // Typing a quantity directly.
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.cart-qty-input');
    if (!input) return;
    const row = input.closest('.cart-item');
    if (!row) return;
    let qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    input.value = qty;
    queueCartUpdate(row, qty);
  });

  // Remove.
  document.addEventListener('click', (e) => {
    const remove = e.target.closest('.cart-item-remove');
    if (!remove) return;
    e.preventDefault();
    const row = remove.closest('.cart-item');
    if (row) queueCartUpdate(row, 0);
  });

  /* ── Cart line updates ────────────────────────────── */
  // Rapid clicks on +/- coalesce into a single request carrying the final
  // quantity, instead of racing each other.
  const pending = new Map();

  function queueCartUpdate(row, qty) {
    const line = row.dataset.line;
    if (!line) return;

    row.classList.add('is-busy');
    showCartError('');

    if (pending.has(line)) clearTimeout(pending.get(line));
    pending.set(line, setTimeout(() => {
      pending.delete(line);
      sendCartUpdate(row, line, qty);
    }, 260));
  }

  function sendCartUpdate(row, line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      // `line` is the 1-based row position and is unambiguous even when the
      // same variant appears twice with different line-item properties.
      body: JSON.stringify({ line: Number(line), quantity: qty })
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        row.classList.remove('is-busy');

        if (!ok || typeof data.item_count === 'undefined') {
          showCartError(data.description || data.message || 'Could not update the cart. Please try again.');
          return;
        }

        // A removal changes every following line index, so re-render.
        if (qty === 0) { window.location.reload(); return; }

        applyCartState(data);
      })
      .catch(() => {
        row.classList.remove('is-busy');
        showCartError('Network problem — the cart was not updated.');
      });
  }

  function applyCartState(cart) {
    updateCartCount(cart.item_count);

    (cart.items || []).forEach((item, i) => {
      const row = document.querySelector('.cart-item[data-line="' + (i + 1) + '"]');
      if (!row) return;

      const total = row.querySelector('[data-line-total]');
      if (total) total.textContent = formatMoney(item.final_line_price);

      const input = row.querySelector('.cart-qty-input');
      if (input && String(item.quantity) !== input.value) input.value = item.quantity;
    });

    const subtotal = document.getElementById('cart-subtotal');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    const total = document.getElementById('cart-total');
    if (total) total.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) window.location.reload();
  }

  function showCartError(msg) {
    const el = document.getElementById('CartError');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  /* ── Product gallery thumbnails ───────────────────── */
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.getElementById('product-main-img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
        if (thumb.dataset.zoomSrc) mainImg.dataset.zoomSrc = thumb.dataset.zoomSrc;
      }
    });
  });

  /* ── Variant selector ─────────────────────────────── */
  const variantSelects = document.querySelectorAll('.variant-select');
  const variantIdInput = document.getElementById('variant-id');
  const addToCartBtn   = document.querySelector('.add-to-cart-btn');

  if (variantSelects.length && variantIdInput) {
    variantSelects.forEach(sel => {
      sel.addEventListener('change', () => {
        const selected = Array.from(variantSelects).map(s => s.value);
        const variants = JSON.parse(document.getElementById('product-variants-json').textContent || '[]');
        const match = variants.find(v => {
          return selected.every((val, i) => v.options[i] === val);
        });
        if (match) {
          variantIdInput.value = match.id;
          if (addToCartBtn) {
            addToCartBtn.disabled = !match.available;
            addToCartBtn.textContent = match.available
              ? (addToCartBtn.dataset.label || 'Add to Cart')
              : 'Sold Out';
          }
          const priceEl = document.getElementById('product-price');
          if (priceEl && match.price) {
            priceEl.textContent = formatMoney(match.price);
          }

          const skuWrap = document.getElementById('ProductSku');
          const skuVal  = document.getElementById('ProductSkuValue');
          if (skuWrap && skuVal) {
            skuVal.textContent = match.sku || '';
            skuWrap.hidden = !match.sku;
          }

          updateEnquiryLinks(match);
        }
      });
    });
  }

  /* ── Enquiry links (WhatsApp / text / email) ──────── */
  // Server-rendered for the first variant; rebuilt here when the shopper picks
  // another, so the SKU in every channel matches what the page shows.
  function updateEnquiryLinks(variant) {
    const box = document.getElementById('ProductEnquiry');
    if (!box || !variant) return;

    const lines = [box.dataset.intro, '', box.dataset.title];
    if (box.dataset.hasVariants === 'true' && variant.title) {
      lines.push('Option: ' + variant.title);
    }
    if (variant.sku) lines.push('SKU: ' + variant.sku);
    lines.push(box.dataset.url);

    // encodeURIComponent gives %20 for spaces and %26 for &, which is what
    // mail and SMS clients need — a "+" would show up literally.
    const body = encodeURIComponent(lines.join('\n'));

    let subject = box.dataset.subjectPrefix + ' ' + box.dataset.title;
    if (variant.sku) subject += ' (' + variant.sku + ')';
    subject = encodeURIComponent(subject);

    box.querySelectorAll('[data-enquiry]').forEach((link) => {
      const to = link.dataset.target;
      switch (link.dataset.enquiry) {
        case 'whatsapp':
          link.href = 'https://wa.me/' + to + '?text=' + body;
          break;
        case 'sms':
          // "?&body=" is the form both iOS and Android accept.
          link.href = 'sms:' + to + '?&body=' + body;
          break;
        case 'email':
          link.href = 'mailto:' + to + '?subject=' + subject + '&body=' + body;
          break;
      }
    });
  }

  /* ── Collection sort ──────────────────────────────── */
  const sortSelect = document.getElementById('sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }


  /* ── Wishlist (localStorage, no app required) ─────── */
  const WISHLIST_KEY = 'ks-wishlist';

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (err) { return []; }
  }
  function writeWishlist(items) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (err) { /* private mode */ }
    paintWishlistCount();
  }
  function inWishlist(handle) {
    return readWishlist().some((i) => i.handle === handle);
  }

  function paintWishlistCount() {
    const n = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = n;
      el.dataset.count = n;
    });
  }

  function paintWishlistButton(btn) {
    const saved = inWishlist(btn.dataset.productHandle);
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', String(saved));
    const label = btn.querySelector('[data-wishlist-label]');
    if (label) label.textContent = saved ? 'Saved to Wishlist' : 'Save to Wishlist';
  }

  function paintAllWishlistButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(paintWishlistButton);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();               // don't follow the product-card link

    const handle = btn.dataset.productHandle;
    if (!handle) return;

    let items = readWishlist();
    if (items.some((i) => i.handle === handle)) {
      items = items.filter((i) => i.handle !== handle);
    } else {
      items.unshift({
        handle: handle,
        title: btn.dataset.productTitle || '',
        url:   btn.dataset.productUrl || '',
        image: btn.dataset.productImage || '',
        price: btn.dataset.productPrice || ''
      });
    }
    writeWishlist(items);
    paintAllWishlistButtons();

    renderWishlistEverywhere();
  });

  paintAllWishlistButtons();
  paintWishlistCount();

  /* ── Wishlist rendering (shared by page + drawer) ── */
  function wishlistCardHTML(item, variant) {
    const wrap = document.createElement(variant === 'drawer' ? 'div' : 'div');
    wrap.className = variant === 'drawer' ? 'wl-row' : 'prod prod--wishlist';

    if (variant === 'drawer') {
      wrap.innerHTML =
        '<a class="wl-row-img" data-link><img loading="lazy" alt=""></a>' +
        '<div class="wl-row-info">' +
          '<a class="wl-row-title" data-title-link></a>' +
          '<p class="wl-row-price" data-price></p>' +
        '</div>' +
        '<button type="button" class="wl-row-remove" data-remove aria-label="Remove">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>';
    } else {
      wrap.innerHTML =
        '<a class="prod-img" data-link>' + (item.image ? '<img loading="lazy" alt="">' : '') + '</a>' +
        '<p class="prod-name"><a data-title-link></a></p>' +
        '<p class="prod-price" data-price></p>' +
        '<button type="button" class="wishlist-remove" data-remove>Remove</button>';
    }

    // Assign via properties, never by interpolating into HTML.
    wrap.querySelectorAll('[data-link], [data-title-link]').forEach((a) => { a.href = item.url; });
    const img = wrap.querySelector('img');
    if (img) { img.src = item.image; img.alt = item.title; }
    wrap.querySelector('[data-title-link]').textContent = item.title;
    wrap.querySelector('[data-price]').textContent = item.price;
    wrap.querySelector('[data-remove]').addEventListener('click', (e) => {
      e.preventDefault();
      writeWishlist(readWishlist().filter((i) => i.handle !== item.handle));
      paintAllWishlistButtons();
      renderWishlistEverywhere();
    });

    return wrap;
  }

  function whatsappShareHref(items) {
    const lines = items.map((i) => '• ' + i.title + ' — ' + window.location.origin + i.url);
    return 'https://wa.me/?text=' + encodeURIComponent('My Kingdom Silver wishlist:\n\n' + lines.join('\n'));
  }

  function renderWishlistEverywhere() {
    const items = readWishlist();

    // Full page
    const grid = document.getElementById('WishlistGrid');
    if (grid) {
      const empty   = document.getElementById('WishlistEmpty');
      const toolbar = document.getElementById('WishlistToolbar');
      grid.innerHTML = '';
      if (empty)   empty.hidden = items.length > 0;
      if (toolbar) toolbar.hidden = items.length === 0;

      const countEl = document.getElementById('WishlistCount');
      if (countEl) countEl.textContent = items.length;

      items.forEach((item) => grid.appendChild(wishlistCardHTML(item, 'page')));

      const share = document.getElementById('WishlistShare');
      if (share) share.href = whatsappShareHref(items);
    }

    // Drawer
    const body = document.getElementById('WishlistDrawerBody');
    if (body) {
      const empty = document.getElementById('WishlistDrawerEmpty');
      const foot  = document.getElementById('WishlistDrawerFoot');
      body.innerHTML = '';
      if (empty) empty.hidden = items.length > 0;
      if (foot)  foot.hidden  = items.length === 0;

      items.forEach((item) => body.appendChild(wishlistCardHTML(item, 'drawer')));

      const share = document.getElementById('WishlistDrawerShare');
      if (share) share.href = whatsappShareHref(items);
    }
  }

  [['WishlistClear', null], ['WishlistDrawerClear', null]].forEach(([id]) => {
    const btn = document.getElementById(id);
    if (!btn) return;
    btn.addEventListener('click', () => {
      if (!confirm('Remove everything from your wishlist?')) return;
      writeWishlist([]);
      paintAllWishlistButtons();
      renderWishlistEverywhere();
    });
  });

  /* ── Wishlist drawer ──────────────────────────────── */
  const wlDrawer = document.getElementById('WishlistDrawer');
  const wlOpen   = document.getElementById('WishlistOpen');
  let wlLastFocus = null;

  function openWishlist() {
    if (!wlDrawer) return;
    wlLastFocus = document.activeElement;
    wlDrawer.hidden = false;
    requestAnimationFrame(() => wlDrawer.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
    if (wlOpen) wlOpen.setAttribute('aria-expanded', 'true');
    const close = wlDrawer.querySelector('.wl-drawer-close');
    if (close) close.focus();
  }

  function closeWishlist() {
    if (!wlDrawer) return;
    wlDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
    if (wlOpen) wlOpen.setAttribute('aria-expanded', 'false');
    setTimeout(() => { wlDrawer.hidden = true; }, 260);
    if (wlLastFocus && wlLastFocus.focus) wlLastFocus.focus();
  }

  if (wlOpen && wlDrawer) {
    wlOpen.addEventListener('click', (e) => {
      // Let modified clicks open the real page in a new tab.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      renderWishlistEverywhere();
      openWishlist();
    });
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-wishlist-close]')) { e.preventDefault(); closeWishlist(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && wlDrawer && !wlDrawer.hidden) closeWishlist();
  });

  renderWishlistEverywhere();

  /* ── Product recommendations ──────────────────────── */
  const recSection = document.getElementById('ProductRecommendations');
  if (recSection && recSection.dataset.url) {
    fetch(recSection.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh  = parsed.getElementById('ProductRecommendations');
        if (fresh && fresh.innerHTML.trim()) {
          recSection.innerHTML = fresh.innerHTML;
          paintAllWishlistButtons();
        }
      })
      .catch(() => { /* recommendations are a nicety — fail quietly */ });
  }

  /* ── Engraving ────────────────────────────────────── */
  const engraving = document.getElementById('EngravingBlock');
  if (engraving) {
    const enable    = document.getElementById('EngravingEnable');
    const body      = document.getElementById('EngravingBody');
    const textarea  = document.getElementById('EngravingText');
    const countEl   = document.getElementById('EngravingCount');
    const clearBtn  = document.getElementById('EngravingClear');
    const keyboard  = document.getElementById('EngravingKeyboard');
    const extraRow  = document.getElementById('EngravingExtraRow');
    const extraCnt  = document.getElementById('EngravingExtraCount');
    const extraOut  = document.getElementById('EngravingExtraOut');
    const totalOut  = document.getElementById('EngravingTotalOut');
    const textProp  = document.getElementById('EngravingProp');
    const feeProp   = document.getElementById('EngravingFeeProp');

    const baseFee   = parseInt(engraving.dataset.baseFee, 10) || 0;
    const perChar   = parseInt(engraving.dataset.perChar, 10) || 0;
    const freeChars = parseInt(engraving.dataset.freeChars, 10) || 0;
    const maxChars  = parseInt(engraving.dataset.maxChars, 10) || 120;

    // Characters that count toward the fee: the engraved marks, not layout.
    function billableLength(text) {
      return text.replace(/[\s\n\r]/g, '').length;
    }

    function engravingTotal() {
      if (!enable.checked) return 0;
      const billable = billableLength(textarea.value);
      const extra    = Math.max(0, billable - freeChars);
      return baseFee + extra * perChar;
    }

    function refreshEngraving() {
      const on = enable.checked;
      body.hidden = !on;

      const text     = textarea.value;
      const billable = billableLength(text);
      const extra    = Math.max(0, billable - freeChars);
      const total    = engravingTotal();

      if (countEl) countEl.textContent = text.length + ' / ' + maxChars + ' characters';

      if (extraRow) extraRow.hidden = extra === 0;
      if (extraCnt) extraCnt.textContent = extra;
      if (extraOut) extraOut.textContent = formatMoney(extra * perChar);
      if (totalOut) totalOut.textContent = formatMoney(total);

      // Only submit the properties when engraving is on and has content.
      const active = on && text.trim().length > 0;
      if (textProp) {
        textProp.disabled = !active;
        textProp.value = text;
      }
      if (feeProp) {
        feeProp.disabled = !active;
        feeProp.value = formatMoney(total);
      }
    }

    enable.addEventListener('change', refreshEngraving);
    textarea.addEventListener('input', refreshEngraving);

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        textarea.value = '';
        refreshEngraving();
        textarea.focus();
      });
    }

    // Language switch
    function setLang(lang) {
      engraving.querySelectorAll('.engraving-lang').forEach((b) => {
        b.classList.toggle('is-active', b.dataset.lang === lang);
      });
      keyboard.querySelectorAll('.engraving-kb-set').forEach((set) => {
        set.hidden = set.dataset.kb !== lang;
      });
      textarea.setAttribute('dir', lang === 'he' ? 'rtl' : 'ltr');
    }
    engraving.querySelectorAll('.engraving-lang').forEach((b) => {
      b.addEventListener('click', () => setLang(b.dataset.lang));
    });
    setLang('en');

    // On-screen keys insert at the caret.
    keyboard.addEventListener('click', (e) => {
      const key = e.target.closest('.engraving-key');
      if (!key) return;
      e.preventDefault();

      const start = textarea.selectionStart || 0;
      const end   = textarea.selectionEnd || 0;
      const value = textarea.value;

      if (key.dataset.action === 'backspace') {
        if (start === end && start > 0) {
          textarea.value = value.slice(0, start - 1) + value.slice(end);
          textarea.setSelectionRange(start - 1, start - 1);
        } else {
          textarea.value = value.slice(0, start) + value.slice(end);
          textarea.setSelectionRange(start, start);
        }
      } else {
        const ch = key.dataset.key;
        if (value.length >= maxChars) return;
        textarea.value = value.slice(0, start) + ch + value.slice(end);
        textarea.setSelectionRange(start + ch.length, start + ch.length);
      }

      textarea.focus();
      refreshEngraving();
    });

    refreshEngraving();

    function showEngravingError(msg) {
      const el = document.getElementById('EngravingError');
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
    }

    // After the item is added, add the matching quantity of the fee product so
    // the engraving charge is actually collected. Quantity is derived from the
    // fee product's real unit price, not assumed.
    window.ksEngravingFee = function () {
      const variant  = parseInt(engraving.dataset.feeVariant, 10);
      const unit     = parseInt(engraving.dataset.feeUnit, 10);
      const total    = engravingTotal();

      showEngravingError('');
      if (!total) return Promise.resolve();

      if (!variant || !unit || unit <= 0) {
        // Text still rides along on the line item; the fee just isn't collected.
        console.warn('[Kingdom Silver] Engraving fee product is not configured — ' +
                     'the engraving text was saved but no charge was added.');
        return Promise.resolve();
      }

      const units = Math.round(total / unit);
      if (units <= 0) return Promise.resolve();

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variant,
            quantity: units,
            properties: { 'Engraving for': (textarea.value || '').slice(0, 60) }
          }]
        })
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (ok) return;
          // Most common cause: the fee product is not published to the Online Store.
          const why = data.description || data.message || 'it could not be added to the cart';
          showEngravingError('The engraving text was saved, but the engraving charge could not be added — ' + why);
          console.warn('[Kingdom Silver] Engraving fee add failed:', data);
        })
        .catch(() => {
          showEngravingError('The engraving text was saved, but the engraving charge could not be added.');
        });
    };
  }


  /* ── Product image zoom ───────────────────────────── */
  const zoomModal = document.getElementById('ZoomModal');
  if (zoomModal) {
    const zoomImg   = document.getElementById('ZoomImage');
    const zoomLevel = document.getElementById('ZoomLevel');
    const frame     = document.getElementById('ProductMainFrame');
    const mainImage = document.getElementById('product-main-img');

    const MIN = 1, MAX = 5;
    let scale = 1, tx = 0, ty = 0;
    let dragging = false, sx = 0, sy = 0;
    let zoomLastFocus = null;

    function applyTransform() {
      zoomImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      zoomImg.style.cursor = scale > 1 ? (dragging ? 'grabbing' : 'grab') : 'zoom-in';
      if (zoomLevel) zoomLevel.textContent = Math.round(scale * 100) + '%';
    }

    function setScale(next, originX, originY) {
      const clamped = Math.min(MAX, Math.max(MIN, next));
      if (clamped === scale) return;

      // Keep the point under the cursor stationary while scaling.
      if (typeof originX === 'number') {
        const rect = zoomImg.getBoundingClientRect();
        const cx = originX - (rect.left + rect.width / 2);
        const cy = originY - (rect.top + rect.height / 2);
        const ratio = clamped / scale;
        tx -= cx * (ratio - 1);
        ty -= cy * (ratio - 1);
      }

      scale = clamped;
      if (scale === 1) { tx = 0; ty = 0; }
      applyTransform();
    }

    function openZoom() {
      if (!mainImage) return;
      zoomLastFocus = document.activeElement;
      zoomImg.src = mainImage.dataset.zoomSrc || mainImage.src;
      zoomImg.alt = mainImage.alt || '';
      scale = 1; tx = 0; ty = 0;
      applyTransform();

      zoomModal.hidden = false;
      requestAnimationFrame(() => zoomModal.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      const close = zoomModal.querySelector('.zoom-close');
      if (close) close.focus();
    }

    function closeZoom() {
      zoomModal.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => { zoomModal.hidden = true; }, 220);
      if (zoomLastFocus && zoomLastFocus.focus) zoomLastFocus.focus();
    }

    if (frame) {
      frame.addEventListener('click', (e) => {
        if (e.target.closest('.zoom-hint') || e.target === mainImage) {
          e.preventDefault();
          openZoom();
        }
      });
    }

    zoomModal.addEventListener('click', (e) => {
      if (e.target.closest('[data-zoom-close]')) { closeZoom(); return; }
      const ctl = e.target.closest('[data-zoom]');
      if (!ctl) return;
      const action = ctl.dataset.zoom;
      if (action === 'in')    setScale(scale + 0.5);
      if (action === 'out')   setScale(scale - 0.5);
      if (action === 'reset') { scale = 1; tx = 0; ty = 0; applyTransform(); }
    });

    // Double-click / tap toggles between fit and 2x.
    zoomImg.addEventListener('dblclick', (e) => {
      e.preventDefault();
      if (scale > 1) { scale = 1; tx = 0; ty = 0; applyTransform(); }
      else setScale(2, e.clientX, e.clientY);
    });

    zoomImg.addEventListener('wheel', (e) => {
      e.preventDefault();
      setScale(scale + (e.deltaY < 0 ? 0.25 : -0.25), e.clientX, e.clientY);
    }, { passive: false });

    zoomImg.addEventListener('pointerdown', (e) => {
      if (scale <= 1) return;
      dragging = true;
      sx = e.clientX - tx;
      sy = e.clientY - ty;
      zoomImg.setPointerCapture(e.pointerId);
      applyTransform();
    });
    zoomImg.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      tx = e.clientX - sx;
      ty = e.clientY - sy;
      applyTransform();
    });
    ['pointerup', 'pointercancel'].forEach((evt) => {
      zoomImg.addEventListener(evt, () => { dragging = false; applyTransform(); });
    });

    // Pinch to zoom.
    let pinchStart = 0, pinchScale = 1;
    zoomImg.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 2) return;
      pinchStart = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      pinchScale = scale;
    }, { passive: true });
    zoomImg.addEventListener('touchmove', (e) => {
      if (e.touches.length !== 2 || !pinchStart) return;
      e.preventDefault();
      const dist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      setScale(pinchScale * (dist / pinchStart));
    }, { passive: false });
    zoomImg.addEventListener('touchend', () => { pinchStart = 0; });

    document.addEventListener('keydown', (e) => {
      if (zoomModal.hidden) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === '+' || e.key === '=') setScale(scale + 0.5);
      if (e.key === '-') setScale(scale - 0.5);
      if (e.key === '0') { scale = 1; tx = 0; ty = 0; applyTransform(); }
    });
  }


  /* ── Header search + predictive suggestions ───────── */
  const navSearch = document.getElementById('NavSearch');
  if (navSearch) {
    const sToggle  = document.getElementById('NavSearchToggle');
    const sPanel   = document.getElementById('NavSearchPanel');
    const sInput   = document.getElementById('NavSearchInput');
    const sClear   = document.getElementById('NavSearchClear');
    const sResults = document.getElementById('PredictiveResults');

    let sTimer = null;
    let sController = null;

    function openSearch() {
      sPanel.hidden = false;
      requestAnimationFrame(() => navSearch.classList.add('is-open'));
      sToggle.setAttribute('aria-expanded', 'true');
      sInput.focus();
    }
    function closeSearch() {
      navSearch.classList.remove('is-open');
      sToggle.setAttribute('aria-expanded', 'false');
      sInput.setAttribute('aria-expanded', 'false');
      hideResults();
      setTimeout(() => { sPanel.hidden = true; }, 200);
    }
    function hideResults() {
      sResults.hidden = true;
      sResults.innerHTML = '';
    }

    sToggle.addEventListener('click', () => {
      if (sPanel.hidden) openSearch(); else closeSearch();
    });

    document.addEventListener('click', (e) => {
      if (!navSearch.contains(e.target) && !sPanel.hidden) closeSearch();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !sPanel.hidden) { closeSearch(); sToggle.focus(); }
    });

    sClear.addEventListener('click', () => {
      sInput.value = '';
      sClear.hidden = true;
      hideResults();
      sInput.focus();
    });

    sInput.addEventListener('input', () => {
      const q = sInput.value.trim();
      sClear.hidden = q.length === 0;

      clearTimeout(sTimer);
      if (q.length < 2) { hideResults(); return; }

      sTimer = setTimeout(() => runPredictive(q), 220);
    });

    function runPredictive(q) {
      if (sController) sController.abort();
      sController = new AbortController();

      // Shopify's predictive search. Results come back already localised to the
      // shopper's active language, so queries in any store language work.
      const url = '/search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product,collection,page,article'
        + '&resources[limit]=6'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      fetch(url, { signal: sController.signal, headers: { 'Accept': 'application/json' } })
        .then((r) => r.json())
        .then((data) => renderPredictive(data.resources.results, q))
        .catch((err) => { if (err.name !== 'AbortError') hideResults(); });
    }

    function renderPredictive(results, q) {
      const products    = results.products || [];
      const collections = results.collections || [];
      const pages       = (results.pages || []).concat(results.articles || []);

      sResults.innerHTML = '';

      if (!products.length && !collections.length && !pages.length) {
        const none = document.createElement('p');
        none.className = 'predictive-none';
        none.textContent = 'Nothing found for “' + q + '”.';
        sResults.appendChild(none);
        sResults.hidden = false;
        sInput.setAttribute('aria-expanded', 'true');
        return;
      }

      if (products.length) {
        sResults.appendChild(groupHeading('Products'));
        products.forEach((p) => {
          const a = document.createElement('a');
          a.className = 'predictive-item';
          a.href = p.url;
          a.setAttribute('role', 'option');

          const img = document.createElement('span');
          img.className = 'predictive-thumb';
          if (p.featured_image && p.featured_image.url) {
            const i = document.createElement('img');
            i.src = p.featured_image.url;
            i.alt = '';
            i.loading = 'lazy';
            img.appendChild(i);
          }

          const info = document.createElement('span');
          info.className = 'predictive-info';
          const t = document.createElement('span');
          t.className = 'predictive-title';
          t.textContent = p.title;              // textContent, never innerHTML
          const pr = document.createElement('span');
          pr.className = 'predictive-price';
          pr.textContent = p.price ? formatMoney(parseInt(p.price, 10)) : '';
          info.appendChild(t);
          info.appendChild(pr);

          a.appendChild(img);
          a.appendChild(info);
          sResults.appendChild(a);
        });
      }

      if (collections.length) {
        sResults.appendChild(groupHeading('Collections'));
        collections.forEach((c) => sResults.appendChild(simpleRow(c.title, c.url)));
      }
      if (pages.length) {
        sResults.appendChild(groupHeading('Pages'));
        pages.forEach((p) => sResults.appendChild(simpleRow(p.title, p.url)));
      }

      const all = document.createElement('a');
      all.className = 'predictive-all';
      all.href = '/search?q=' + encodeURIComponent(q);
      all.textContent = 'See all results for “' + q + '”';
      sResults.appendChild(all);

      sResults.hidden = false;
      sInput.setAttribute('aria-expanded', 'true');
    }

    function groupHeading(text) {
      const h = document.createElement('p');
      h.className = 'predictive-heading';
      h.textContent = text;
      return h;
    }
    function simpleRow(title, url) {
      const a = document.createElement('a');
      a.className = 'predictive-item predictive-item--plain';
      a.href = url;
      a.setAttribute('role', 'option');
      const t = document.createElement('span');
      t.className = 'predictive-title';
      t.textContent = title;
      a.appendChild(t);
      return a;
    }

    // Keyboard navigation through suggestions.
    sInput.addEventListener('keydown', (e) => {
      if (sResults.hidden) return;
      const items = Array.from(sResults.querySelectorAll('.predictive-item, .predictive-all'));
      if (!items.length) return;
      const idx = items.indexOf(document.activeElement);

      if (e.key === 'ArrowDown') { e.preventDefault(); (items[idx + 1] || items[0]).focus(); }
      if (e.key === 'ArrowUp')   { e.preventDefault(); (items[idx - 1] || items[items.length - 1]).focus(); }
    });
    sResults.addEventListener('keydown', (e) => {
      const items = Array.from(sResults.querySelectorAll('.predictive-item, .predictive-all'));
      const idx = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[idx + 1] || items[0]).focus(); }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (idx <= 0) sInput.focus(); else items[idx - 1].focus();
      }
    });
  }

  /* ── Collection filters ───────────────────────────── */
  const filterForm = document.getElementById('FilterForm');
  if (filterForm) {
    const panel     = document.getElementById('CollectionFilters');
    const openBtn   = document.getElementById('FilterToggle');
    const closeBtn  = document.getElementById('FilterClose');
    let filterTimer = null;

    function submitFilters() {
      const data = new FormData(filterForm);
      const params = new URLSearchParams();

      for (const [key, value] of data.entries()) {
        if (value !== '' && value != null) params.append(key, value);
      }

      const base = window.location.pathname;
      const qs = params.toString();
      window.location.href = qs ? base + '?' + qs : base;
    }

    // Checkboxes apply immediately; price inputs wait until typing settles.
    filterForm.addEventListener('change', (e) => {
      if (e.target.type === 'checkbox') submitFilters();
    });
    filterForm.addEventListener('input', (e) => {
      if (e.target.type !== 'number') return;
      clearTimeout(filterTimer);
      filterTimer = setTimeout(submitFilters, 700);
    });
    filterForm.addEventListener('submit', (e) => { e.preventDefault(); submitFilters(); });

    function openFilters() {
      panel.classList.add('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeFilters() {
      panel.classList.remove('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (openBtn)  openBtn.addEventListener('click', () => {
      panel.classList.contains('is-open') ? closeFilters() : openFilters();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closeFilters();
    });
  }


  /* ── Budget finder ────────────────────────────────── */
  const budget = document.getElementById('BudgetFinder');
  if (budget) {
    const slider  = document.getElementById('BudgetSlider');
    const input   = document.getElementById('BudgetInput');
    const grid    = document.getElementById('BudgetGrid');
    const summary = document.getElementById('BudgetSummary');
    const empty   = document.getElementById('BudgetEmpty');
    const seeAll  = document.getElementById('BudgetSeeAll');

    const floorCents = parseInt(budget.dataset.min, 10) || 0;
    // Slider ceiling, rounded up to a step boundary so the top is reachable.
    const ceilCents  = parseInt(budget.dataset.max, 10) || 0;
    // The dearest piece actually on sale, for wording.
    const realMax    = parseInt(budget.dataset.realMax, 10) || ceilCents;
    const items      = Array.from(grid ? grid.querySelectorAll('.budget-item') : []);
    const baseUrl    = seeAll ? seeAll.getAttribute('href').split('?')[0] : '';

    function apply(cents) {
      // Never below the cheapest in-stock piece — a lower figure can only ever
      // return nothing, which reads as a broken filter rather than an answer.
      const budgetCents = Math.max(floorCents, Math.min(ceilCents, cents));

      let shown = 0;
      items.forEach((item) => {
        const price = parseInt(item.dataset.price, 10);
        const fits  = price <= budgetCents;
        item.hidden = !fits;
        if (fits) shown += 1;
      });

      if (summary) {
        if (shown === 0) {
          summary.textContent = '';
        } else if (budgetCents >= realMax) {
          // At the top of the track the figure is a rounded-up step boundary,
          // so quoting it would name a price no piece actually costs.
          summary.textContent = 'Showing all ' + shown +
            (shown === 1 ? ' piece' : ' pieces');
        } else {
          summary.textContent = shown + (shown === 1 ? ' piece' : ' pieces') +
            ' at ' + formatMoney(budgetCents) + ' or less';
        }
      }
      if (empty) empty.hidden = shown !== 0;

      if (seeAll && baseUrl) {
        // Shopify's own storefront price filter, so the collection page opens
        // already narrowed to the same figure. At the very top there is nothing
        // to narrow, so link to the unfiltered collection.
        seeAll.href = budgetCents >= realMax
          ? baseUrl
          : baseUrl + '?filter.v.price.lte=' + (budgetCents / 100).toFixed(2);
      }
      return budgetCents;
    }

    function syncFromSlider() {
      const cents = apply(parseInt(slider.value, 10));
      if (input) input.value = Math.ceil(cents / 100);
    }

    function syncFromInput() {
      const dollars = parseFloat(input.value);
      if (isNaN(dollars)) return;
      const cents = apply(Math.round(dollars * 100));
      if (slider) slider.value = cents;
    }

    if (slider) slider.addEventListener('input', syncFromSlider);
    if (input) {
      // Filter as they type, but only snap the typed value into range on blur —
      // clamping mid-keystroke fights the person typing.
      input.addEventListener('input', () => {
        const dollars = parseFloat(input.value);
        if (isNaN(dollars)) return;
        const cents = Math.round(dollars * 100);
        apply(cents);
        if (slider) slider.value = Math.max(floorCents, Math.min(ceilCents, cents));
      });
      input.addEventListener('change', syncFromInput);
      input.addEventListener('blur', syncFromInput);
    }

    apply(ceilCents);
  }

})();
